export const LIT_TYPES = ['NUMBER', 'STRING', 'DATETIME'];
export const NER_TYPES = ['LOCATION', 'ORGANIZATION', 'PERSON', 'OTHER'];
export const COLUMN_TYPES = ['LIT', 'NE', 'IGNORED'];
